// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Box } from '@mui/system';

export const Wrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.common.white};
`;
